import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, withModifiers as _withModifiers, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "hero" }
const _hoisted_3 = { class: "hero-body" }
const _hoisted_4 = { class: "container" }
const _hoisted_5 = { class: "content" }
const _hoisted_6 = { class: "header is-flex is-justify-content-space-between" }
const _hoisted_7 = { class: "title is-4" }
const _hoisted_8 = {
  key: 0,
  class: "subtitle is-6 has-text-grey"
}
const _hoisted_9 = {
  key: 1,
  class: "subtitle is-6 has-text-grey"
}
const _hoisted_10 = {
  key: 2,
  class: "subtitle is-6 has-text-grey"
}
const _hoisted_11 = {
  key: 3,
  class: "subtitle is-6 has-text-grey"
}
const _hoisted_12 = { class: "content-body" }
const _hoisted_13 = {
  key: 0,
  class: "table"
}
const _hoisted_14 = { class: "" }
const _hoisted_15 = { class: "" }
const _hoisted_16 = { class: "" }
const _hoisted_17 = { class: "" }
const _hoisted_18 = { class: "" }
const _hoisted_19 = {
  key: 1,
  class: "field is-grouped mb-4 is-flex is-flex-wrap-wrap is-align-items-center",
  style: {"gap":"10px"}
}
const _hoisted_20 = { class: "is-flex is-align-items-center is-flex-direction-column-mobile" }
const _hoisted_21 = { class: "label mr-2" }
const _hoisted_22 = { class: "control is-fullwidth" }
const _hoisted_23 = { class: "is-flex is-align-items-center is-flex-direction-column-mobile" }
const _hoisted_24 = { class: "label mr-2" }
const _hoisted_25 = { class: "control is-fullwidth" }
const _hoisted_26 = { class: "control is-fullwidth" }
const _hoisted_27 = {
  key: 2,
  class: "table-container mb-2",
  style: {"max-height":"420px","overflow-y":"auto"}
}
const _hoisted_28 = { class: "table" }
const _hoisted_29 = { class: "" }
const _hoisted_30 = { class: "" }
const _hoisted_31 = { class: "" }
const _hoisted_32 = { class: "" }
const _hoisted_33 = { class: "" }
const _hoisted_34 = { class: "" }
const _hoisted_35 = { class: "" }
const _hoisted_36 = { class: "columns is-vcentered" }
const _hoisted_37 = { class: "column is-6" }
const _hoisted_38 = { class: "field is-horizontal" }
const _hoisted_39 = { class: "field-label is-normal" }
const _hoisted_40 = { class: "label" }
const _hoisted_41 = { class: "field-body" }
const _hoisted_42 = { class: "field" }
const _hoisted_43 = { class: "control" }
const _hoisted_44 = { class: "select is-fullwidth" }
const _hoisted_45 = ["value"]
const _hoisted_46 = { class: "column is-5" }
const _hoisted_47 = ["innerHTML"]
const _hoisted_48 = { class: "box availability-config-box" }
const _hoisted_49 = { class: "columns is-1" }
const _hoisted_50 = { class: "column" }
const _hoisted_51 = { class: "table is-narrow is-fullwidth" }
const _hoisted_52 = {
  class: "has-text-centered mx-0 px-0",
  colspan: "3"
}
const _hoisted_53 = { class: "mx-0 px-0" }
const _hoisted_54 = { class: "is-flex is-justify-content-start mx-0 px-0" }
const _hoisted_55 = { key: 0 }
const _hoisted_56 = {
  class: "has-text-centered mx-0 px-0",
  colspan: "4"
}
const _hoisted_57 = { class: "column" }
const _hoisted_58 = { class: "table is-narrow is-fullwidth" }
const _hoisted_59 = {
  class: "has-text-centered mx-0 px-0",
  colspan: "3"
}
const _hoisted_60 = { class: "mx-0 px-0" }
const _hoisted_61 = { class: "is-flex is-justify-content-start mx-0 px-0" }
const _hoisted_62 = { key: 0 }
const _hoisted_63 = {
  class: "has-text-centered mx-0 px-0",
  colspan: "4"
}
const _hoisted_64 = { class: "column" }
const _hoisted_65 = { class: "table is-narrow is-fullwidth" }
const _hoisted_66 = {
  class: "has-text-centered mx-0 px-0",
  colspan: "3"
}
const _hoisted_67 = { class: "mx-0 px-0" }
const _hoisted_68 = { class: "is-flex is-justify-content-start mx-0 px-0" }
const _hoisted_69 = { key: 0 }
const _hoisted_70 = {
  class: "has-text-centered mx-0 px-0",
  colspan: "4"
}
const _hoisted_71 = { class: "column" }
const _hoisted_72 = { class: "table is-narrow is-fullwidth" }
const _hoisted_73 = {
  class: "has-text-centered mx-0 px-0",
  colspan: "3"
}
const _hoisted_74 = { class: "mx-0 px-0" }
const _hoisted_75 = { class: "is-flex is-justify-content-start mx-0 px-0" }
const _hoisted_76 = { key: 0 }
const _hoisted_77 = {
  class: "has-text-centered mx-0 px-0",
  colspan: "4"
}
const _hoisted_78 = { class: "column" }
const _hoisted_79 = { class: "table is-narrow is-fullwidth" }
const _hoisted_80 = {
  class: "has-text-centered mx-0 px-0",
  colspan: "3"
}
const _hoisted_81 = { class: "mx-0 px-0" }
const _hoisted_82 = { class: "is-flex is-justify-content-start mx-0 px-0" }
const _hoisted_83 = { key: 0 }
const _hoisted_84 = {
  class: "has-text-centered mx-0 px-0",
  colspan: "4"
}
const _hoisted_85 = { class: "column" }
const _hoisted_86 = { class: "table is-narrow is-fullwidth" }
const _hoisted_87 = {
  class: "has-text-centered mx-0 px-0",
  colspan: "3"
}
const _hoisted_88 = { class: "mx-0 px-0" }
const _hoisted_89 = { class: "is-flex is-justify-content-start mx-0 px-0" }
const _hoisted_90 = { key: 0 }
const _hoisted_91 = {
  class: "has-text-centered mx-0 px-0",
  colspan: "4"
}
const _hoisted_92 = { class: "column" }
const _hoisted_93 = { class: "table is-narrow is-fullwidth" }
const _hoisted_94 = {
  class: "has-text-centered mx-0 px-0",
  colspan: "3"
}
const _hoisted_95 = { class: "mx-0 px-0" }
const _hoisted_96 = { class: "is-flex is-justify-content-start mx-0 px-0" }
const _hoisted_97 = { key: 0 }
const _hoisted_98 = {
  class: "has-text-centered mx-0 px-0",
  colspan: "4"
}
const _hoisted_99 = { class: "field is-grouped is-grouped-right" }
const _hoisted_100 = { class: "control" }
const _hoisted_101 = {
  type: "submit",
  class: "button is-primary"
}
const _hoisted_102 = { class: "control" }
const _hoisted_103 = { key: 5 }
const _hoisted_104 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Navbar = _resolveComponent("Navbar")!
  const _component_UserTableRow = _resolveComponent("UserTableRow")!
  const _component_VueDatePicker = _resolveComponent("VueDatePicker")!
  const _component_VetRecordTableRow = _resolveComponent("VetRecordTableRow")!
  const _component_AppointmentDataForm = _resolveComponent("AppointmentDataForm")!
  const _component_WorkingIntervalTableRow = _resolveComponent("WorkingIntervalTableRow")!

  return (_ctx.isIniDataReady)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", null, [
          _createVNode(_component_Navbar),
          _createElementVNode("section", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", null, [
                      _createElementVNode("h4", _hoisted_7, _toDisplayString(_ctx.$t('Vet.Mode')), 1),
                      (_ctx.getVetMode == 'availabilityconfig' && !_ctx.editingAvailabilityConfig)
                        ? (_openBlock(), _createElementBlock("h6", _hoisted_8, _toDisplayString(_ctx.$t('Vet.AvailabilityCalendar')), 1))
                        : _createCommentVNode("", true),
                      (_ctx.getVetMode == 'availabilityslots')
                        ? (_openBlock(), _createElementBlock("h6", _hoisted_9, _toDisplayString(_ctx.$t('Vet.VisualizeSlots')), 1))
                        : _createCommentVNode("", true),
                      (_ctx.getVetMode == 'customers')
                        ? (_openBlock(), _createElementBlock("h6", _hoisted_10, _toDisplayString(_ctx.$t('Vet.VisualizeCustomers')), 1))
                        : _createCommentVNode("", true),
                      (_ctx.getVetMode == 'appointments' && !_ctx.getShowingAppointmentData)
                        ? (_openBlock(), _createElementBlock("h6", _hoisted_11, _toDisplayString(_ctx.$t('Vet.VisualizeMyAppointments')), 1))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    (_ctx.getVetMode == 'customers')
                      ? (_openBlock(), _createElementBlock("table", _hoisted_13, [
                          _createElementVNode("thead", null, [
                            _createElementVNode("tr", null, [
                              _createElementVNode("th", null, _toDisplayString(_ctx.$t('UserData.Id')), 1),
                              _createElementVNode("th", _hoisted_14, _toDisplayString(_ctx.$t('UserData.Name')), 1),
                              _createElementVNode("th", _hoisted_15, _toDisplayString(_ctx.$t('UserData.Email')), 1),
                              _createElementVNode("th", _hoisted_16, _toDisplayString(_ctx.$t('UserData.Phone')), 1),
                              _createElementVNode("th", _hoisted_17, _toDisplayString(_ctx.$t('CustomerData.Address')), 1),
                              _createElementVNode("th", _hoisted_18, _toDisplayString(_ctx.$t('CustomerData.VATNumber')), 1)
                            ])
                          ]),
                          _createElementVNode("tbody", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getUsers, (user) => {
                              return (_openBlock(), _createElementBlock("tr", {
                                key: user.user_id
                              }, [
                                _createVNode(_component_UserTableRow, {
                                  "user-data": user,
                                  parentShowCustomerData: _ctx.showCustomerData
                                }, null, 8, ["user-data", "parentShowCustomerData"])
                              ]))
                            }), 128))
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.getVetMode == 'appointments' && !_ctx.getShowingAppointmentData)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                          _createElementVNode("div", _hoisted_20, [
                            _createElementVNode("label", _hoisted_21, _toDisplayString(_ctx.$t('General.From')), 1),
                            _createElementVNode("div", _hoisted_22, [
                              _createVNode(_component_VueDatePicker, {
                                id: "filter_start_date",
                                modelValue: _ctx.filterStartDate,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filterStartDate) = $event)),
                                placeholder: _ctx.$t('General.PleaseSelectDate'),
                                "model-type": "yyyy-MM-dd",
                                "auto-apply": "",
                                "min-date": new Date(1950, 0, 1),
                                "max-date": _ctx.maxDate,
                                "enable-time-picker": false,
                                "prevent-min-max-navigation": "",
                                format: "yyyy-MM-dd",
                                class: "is-fullwidth is-align-self-flex-end-mobile"
                              }, null, 8, ["modelValue", "placeholder", "min-date", "max-date"])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_23, [
                            _createElementVNode("label", _hoisted_24, _toDisplayString(_ctx.$t('General.To')), 1),
                            _createElementVNode("div", _hoisted_25, [
                              _createVNode(_component_VueDatePicker, {
                                id: "filter_end_date",
                                modelValue: _ctx.filterEndDate,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filterEndDate) = $event)),
                                placeholder: _ctx.$t('General.PleaseSelectDate'),
                                "model-type": "yyyy-MM-dd",
                                "auto-apply": "",
                                "min-date": new Date(1950, 0, 1),
                                "max-date": _ctx.maxDate,
                                "enable-time-picker": false,
                                "prevent-min-max-navigation": "",
                                format: "yyyy-MM-dd",
                                class: "is-fullwidth is-align-self-flex-end-mobile"
                              }, null, 8, ["modelValue", "placeholder", "min-date", "max-date"])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_26, [
                            _createElementVNode("button", {
                              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.resetDateRange && _ctx.resetDateRange(...args))),
                              class: "button is-light is-fullwidth"
                            }, _toDisplayString(_ctx.$t('General.ResetFilter')), 1)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.getVetMode == 'appointments' && !_ctx.getShowingAppointmentData)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                          _createElementVNode("table", _hoisted_28, [
                            _createElementVNode("thead", null, [
                              _createElementVNode("tr", null, [
                                _createElementVNode("th", _hoisted_29, _toDisplayString(_ctx.$t('AppointmentData.Appointment')), 1),
                                _createElementVNode("th", _hoisted_30, _toDisplayString(_ctx.$t('AppointmentData.Specialty')), 1),
                                _createElementVNode("th", _hoisted_31, _toDisplayString(_ctx.$t('AppointmentData.Customer')), 1),
                                _createElementVNode("th", _hoisted_32, _toDisplayString(_ctx.$t('AppointmentData.Pet')), 1),
                                _createElementVNode("th", _hoisted_33, _toDisplayString(_ctx.$t('AppointmentData.Status')), 1),
                                _createElementVNode("th", _hoisted_34, _toDisplayString(_ctx.$t('AppointmentData.StatusTime')), 1),
                                _createElementVNode("th", _hoisted_35, _toDisplayString(_ctx.$t('AppointmentData.Link')), 1),
                                _cache[21] || (_cache[21] = _createElementVNode("th", null, null, -1))
                              ])
                            ]),
                            _createElementVNode("tbody", null, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredAppointments, (appointment) => {
                                return (_openBlock(), _createElementBlock("tr", {
                                  key: appointment.appointment_id
                                }, [
                                  _createVNode(_component_VetRecordTableRow, { "appointment-data": appointment }, null, 8, ["appointment-data"])
                                ]))
                              }), 128))
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.getVetMode == 'appointments' && _ctx.getShowingAppointmentData)
                      ? (_openBlock(), _createBlock(_component_AppointmentDataForm, { key: 3 }))
                      : _createCommentVNode("", true),
                    (_ctx.getVetMode == 'availabilityconfig')
                      ? (_openBlock(), _createElementBlock("form", {
                          key: 4,
                          onSubmit: _cache[20] || (_cache[20] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.editAvailabilityConfigMeth && _ctx.editAvailabilityConfigMeth(...args)), ["prevent"]))
                        }, [
                          _createElementVNode("div", _hoisted_36, [
                            _createElementVNode("div", _hoisted_37, [
                              _createElementVNode("div", _hoisted_38, [
                                _createElementVNode("div", _hoisted_39, [
                                  _createElementVNode("label", _hoisted_40, _toDisplayString(_ctx.$t('Vet.AvailabilityWeek')), 1)
                                ]),
                                _createElementVNode("div", _hoisted_41, [
                                  _createElementVNode("div", _hoisted_42, [
                                    _createElementVNode("div", _hoisted_43, [
                                      _createElementVNode("div", _hoisted_44, [
                                        _withDirectives(_createElementVNode("select", {
                                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.weekStart) = $event)),
                                          required: "",
                                          class: "px-6",
                                          onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.confirmWeeklyProfileChange(_ctx.weekStart, _ctx.$t)))
                                        }, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getAvailabilityWeeks, (week) => {
                                            return (_openBlock(), _createElementBlock("option", {
                                              key: week.number,
                                              value: week.date_start
                                            }, _toDisplayString(week.number % 100) + " " + _toDisplayString(_ctx.$t('General.Of')) + " " + _toDisplayString(week.number.toString().slice(0, 4)) + " : " + _toDisplayString(_ctx.$t('General.From')) + " " + _toDisplayString(new Date(week.date_start).toLocaleDateString(_ctx.$i18n.locale)) + " " + _toDisplayString(_ctx.$t('General.To')) + " " + _toDisplayString(new Date(week.date_end).toLocaleDateString(_ctx.$i18n.locale)), 9, _hoisted_45))
                                          }), 128))
                                        ], 544), [
                                          [_vModelSelect, _ctx.weekStart]
                                        ])
                                      ])
                                    ])
                                  ])
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_46, [
                              _createElementVNode("div", {
                                class: "notification is-light is-small",
                                innerHTML: _ctx.$t('Vet.ImpactNote')
                              }, null, 8, _hoisted_47)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_48, [
                            _createElementVNode("div", _hoisted_49, [
                              _createElementVNode("div", _hoisted_50, [
                                _createElementVNode("table", _hoisted_51, [
                                  _createElementVNode("thead", null, [
                                    _createElementVNode("tr", null, [
                                      _createElementVNode("th", _hoisted_52, _toDisplayString(_ctx.$t('General.Monday')), 1),
                                      _createElementVNode("th", _hoisted_53, [
                                        _createElementVNode("div", _hoisted_54, [
                                          _createElementVNode("button", {
                                            type: "button",
                                            class: "button is-primary is-light is-small is-rounded",
                                            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.addWorkingIntervalMeth('monday')))
                                          }, _cache[22] || (_cache[22] = [
                                            _createElementVNode("i", { class: "fa-solid fa-plus" }, null, -1)
                                          ]))
                                        ])
                                      ])
                                    ])
                                  ]),
                                  _createElementVNode("tbody", null, [
                                    (_ctx.obtainAvailabilityConfigWorkingIntervals('monday').length == 0)
                                      ? (_openBlock(), _createElementBlock("tr", _hoisted_55, [
                                          _createElementVNode("td", _hoisted_56, _toDisplayString(_ctx.$t('General.Unavailable')), 1)
                                        ]))
                                      : _createCommentVNode("", true),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.obtainAvailabilityConfigWorkingIntervals('monday'), (workingInterval) => {
                                      return (_openBlock(), _createElementBlock("tr", {
                                        class: "mx-0",
                                        key: workingInterval.pos
                                      }, [
                                        _createVNode(_component_WorkingIntervalTableRow, {
                                          "interval-data": workingInterval,
                                          extractDateFromDayOfWeek: _ctx.extractDateFromDayOfWeek,
                                          onChangesMade: _cache[6] || (_cache[6] = ($event: any) => (_ctx.flagChangesMade(true)))
                                        }, null, 8, ["interval-data", "extractDateFromDayOfWeek"])
                                      ]))
                                    }), 128))
                                  ])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_57, [
                                _createElementVNode("table", _hoisted_58, [
                                  _createElementVNode("thead", null, [
                                    _createElementVNode("tr", null, [
                                      _createElementVNode("th", _hoisted_59, _toDisplayString(_ctx.$t('General.Tuesday')), 1),
                                      _createElementVNode("th", _hoisted_60, [
                                        _createElementVNode("div", _hoisted_61, [
                                          _createElementVNode("div", null, [
                                            _createElementVNode("button", {
                                              type: "button",
                                              class: "button is-primary is-light is-small is-rounded",
                                              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.addWorkingIntervalMeth('tuesday')))
                                            }, _cache[23] || (_cache[23] = [
                                              _createElementVNode("i", { class: "fa-solid fa-plus" }, null, -1)
                                            ]))
                                          ])
                                        ])
                                      ])
                                    ])
                                  ]),
                                  _createElementVNode("tbody", null, [
                                    (_ctx.obtainAvailabilityConfigWorkingIntervals('tuesday').length == 0)
                                      ? (_openBlock(), _createElementBlock("tr", _hoisted_62, [
                                          _createElementVNode("td", _hoisted_63, _toDisplayString(_ctx.$t('General.Unavailable')), 1)
                                        ]))
                                      : _createCommentVNode("", true),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.obtainAvailabilityConfigWorkingIntervals('tuesday'), (workingInterval) => {
                                      return (_openBlock(), _createElementBlock("tr", {
                                        class: "is-spaced",
                                        key: workingInterval.pos
                                      }, [
                                        _createVNode(_component_WorkingIntervalTableRow, {
                                          "interval-data": workingInterval,
                                          extractDateFromDayOfWeek: _ctx.extractDateFromDayOfWeek,
                                          onChangesMade: _cache[8] || (_cache[8] = ($event: any) => (_ctx.flagChangesMade(true)))
                                        }, null, 8, ["interval-data", "extractDateFromDayOfWeek"])
                                      ]))
                                    }), 128))
                                  ])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_64, [
                                _createElementVNode("table", _hoisted_65, [
                                  _createElementVNode("thead", null, [
                                    _createElementVNode("tr", null, [
                                      _createElementVNode("th", _hoisted_66, _toDisplayString(_ctx.$t('General.Wednesday')), 1),
                                      _createElementVNode("th", _hoisted_67, [
                                        _createElementVNode("div", _hoisted_68, [
                                          _createElementVNode("button", {
                                            type: "button",
                                            class: "button is-primary is-light is-small is-rounded",
                                            onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.addWorkingIntervalMeth('wednesday')))
                                          }, _cache[24] || (_cache[24] = [
                                            _createElementVNode("i", { class: "fa-solid fa-plus" }, null, -1)
                                          ]))
                                        ])
                                      ])
                                    ])
                                  ]),
                                  _createElementVNode("tbody", null, [
                                    (_ctx.obtainAvailabilityConfigWorkingIntervals('wednesday').length == 0)
                                      ? (_openBlock(), _createElementBlock("tr", _hoisted_69, [
                                          _createElementVNode("td", _hoisted_70, _toDisplayString(_ctx.$t('General.Unavailable')), 1)
                                        ]))
                                      : _createCommentVNode("", true),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.obtainAvailabilityConfigWorkingIntervals('wednesday'), (workingInterval) => {
                                      return (_openBlock(), _createElementBlock("tr", {
                                        class: "is-spaced",
                                        key: workingInterval.pos
                                      }, [
                                        _createVNode(_component_WorkingIntervalTableRow, {
                                          "interval-data": workingInterval,
                                          extractDateFromDayOfWeek: _ctx.extractDateFromDayOfWeek,
                                          onChangesMade: _cache[10] || (_cache[10] = ($event: any) => (_ctx.flagChangesMade(true)))
                                        }, null, 8, ["interval-data", "extractDateFromDayOfWeek"])
                                      ]))
                                    }), 128))
                                  ])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_71, [
                                _createElementVNode("table", _hoisted_72, [
                                  _createElementVNode("thead", null, [
                                    _createElementVNode("tr", null, [
                                      _createElementVNode("th", _hoisted_73, _toDisplayString(_ctx.$t('General.Thursday')), 1),
                                      _createElementVNode("th", _hoisted_74, [
                                        _createElementVNode("div", _hoisted_75, [
                                          _createElementVNode("button", {
                                            type: "button",
                                            class: "button is-primary is-light is-small is-rounded",
                                            onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.addWorkingIntervalMeth('thursday')))
                                          }, _cache[25] || (_cache[25] = [
                                            _createElementVNode("i", { class: "fa-solid fa-plus" }, null, -1)
                                          ]))
                                        ])
                                      ])
                                    ])
                                  ]),
                                  _createElementVNode("tbody", null, [
                                    (_ctx.obtainAvailabilityConfigWorkingIntervals('thursday').length == 0)
                                      ? (_openBlock(), _createElementBlock("tr", _hoisted_76, [
                                          _createElementVNode("td", _hoisted_77, _toDisplayString(_ctx.$t('General.Unavailable')), 1)
                                        ]))
                                      : _createCommentVNode("", true),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.obtainAvailabilityConfigWorkingIntervals('thursday'), (workingInterval) => {
                                      return (_openBlock(), _createElementBlock("tr", {
                                        class: "is-spaced",
                                        key: workingInterval.pos
                                      }, [
                                        _createVNode(_component_WorkingIntervalTableRow, {
                                          "interval-data": workingInterval,
                                          extractDateFromDayOfWeek: _ctx.extractDateFromDayOfWeek,
                                          onChangesMade: _cache[12] || (_cache[12] = ($event: any) => (_ctx.flagChangesMade(true)))
                                        }, null, 8, ["interval-data", "extractDateFromDayOfWeek"])
                                      ]))
                                    }), 128))
                                  ])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_78, [
                                _createElementVNode("table", _hoisted_79, [
                                  _createElementVNode("thead", null, [
                                    _createElementVNode("tr", null, [
                                      _createElementVNode("th", _hoisted_80, _toDisplayString(_ctx.$t('General.Friday')), 1),
                                      _createElementVNode("th", _hoisted_81, [
                                        _createElementVNode("div", _hoisted_82, [
                                          _createElementVNode("button", {
                                            type: "button",
                                            class: "button is-primary is-light is-small is-rounded",
                                            onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.addWorkingIntervalMeth('friday')))
                                          }, _cache[26] || (_cache[26] = [
                                            _createElementVNode("i", { class: "fa-solid fa-plus" }, null, -1)
                                          ]))
                                        ])
                                      ])
                                    ])
                                  ]),
                                  _createElementVNode("tbody", null, [
                                    (_ctx.obtainAvailabilityConfigWorkingIntervals('friday').length == 0)
                                      ? (_openBlock(), _createElementBlock("tr", _hoisted_83, [
                                          _createElementVNode("td", _hoisted_84, _toDisplayString(_ctx.$t('General.Unavailable')), 1)
                                        ]))
                                      : _createCommentVNode("", true),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.obtainAvailabilityConfigWorkingIntervals('friday'), (workingInterval) => {
                                      return (_openBlock(), _createElementBlock("tr", {
                                        class: "is-spaced",
                                        key: workingInterval.pos
                                      }, [
                                        _createVNode(_component_WorkingIntervalTableRow, {
                                          "interval-data": workingInterval,
                                          extractDateFromDayOfWeek: _ctx.extractDateFromDayOfWeek,
                                          onChangesMade: _cache[14] || (_cache[14] = ($event: any) => (_ctx.flagChangesMade(true)))
                                        }, null, 8, ["interval-data", "extractDateFromDayOfWeek"])
                                      ]))
                                    }), 128))
                                  ])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_85, [
                                _createElementVNode("table", _hoisted_86, [
                                  _createElementVNode("thead", null, [
                                    _createElementVNode("tr", null, [
                                      _createElementVNode("th", _hoisted_87, _toDisplayString(_ctx.$t('General.Saturday')), 1),
                                      _createElementVNode("th", _hoisted_88, [
                                        _createElementVNode("div", _hoisted_89, [
                                          _createElementVNode("button", {
                                            type: "button",
                                            class: "button is-primary is-light is-small is-rounded",
                                            onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.addWorkingIntervalMeth('saturday')))
                                          }, _cache[27] || (_cache[27] = [
                                            _createElementVNode("i", { class: "fa-solid fa-plus" }, null, -1)
                                          ]))
                                        ])
                                      ])
                                    ])
                                  ]),
                                  _createElementVNode("tbody", null, [
                                    (_ctx.obtainAvailabilityConfigWorkingIntervals('saturday').length == 0)
                                      ? (_openBlock(), _createElementBlock("tr", _hoisted_90, [
                                          _createElementVNode("td", _hoisted_91, _toDisplayString(_ctx.$t('General.Unavailable')), 1)
                                        ]))
                                      : _createCommentVNode("", true),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.obtainAvailabilityConfigWorkingIntervals('saturday'), (workingInterval) => {
                                      return (_openBlock(), _createElementBlock("tr", {
                                        class: "is-spaced",
                                        key: workingInterval.pos
                                      }, [
                                        _createVNode(_component_WorkingIntervalTableRow, {
                                          "interval-data": workingInterval,
                                          extractDateFromDayOfWeek: _ctx.extractDateFromDayOfWeek,
                                          onChangesMade: _cache[16] || (_cache[16] = ($event: any) => (_ctx.flagChangesMade(true)))
                                        }, null, 8, ["interval-data", "extractDateFromDayOfWeek"])
                                      ]))
                                    }), 128))
                                  ])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_92, [
                                _createElementVNode("table", _hoisted_93, [
                                  _createElementVNode("thead", null, [
                                    _createElementVNode("tr", null, [
                                      _createElementVNode("th", _hoisted_94, _toDisplayString(_ctx.$t('General.Sunday')), 1),
                                      _createElementVNode("th", _hoisted_95, [
                                        _createElementVNode("div", _hoisted_96, [
                                          _createElementVNode("button", {
                                            type: "button",
                                            class: "button is-primary is-light is-small is-rounded",
                                            onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.addWorkingIntervalMeth('sunday')))
                                          }, _cache[28] || (_cache[28] = [
                                            _createElementVNode("i", { class: "fa-solid fa-plus" }, null, -1)
                                          ]))
                                        ])
                                      ])
                                    ])
                                  ]),
                                  _createElementVNode("tbody", null, [
                                    (_ctx.obtainAvailabilityConfigWorkingIntervals('sunday').length == 0)
                                      ? (_openBlock(), _createElementBlock("tr", _hoisted_97, [
                                          _createElementVNode("td", _hoisted_98, _toDisplayString(_ctx.$t('General.Unavailable')), 1)
                                        ]))
                                      : _createCommentVNode("", true),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.obtainAvailabilityConfigWorkingIntervals('sunday'), (workingInterval) => {
                                      return (_openBlock(), _createElementBlock("tr", {
                                        class: "is-spaced",
                                        key: workingInterval.pos
                                      }, [
                                        _createVNode(_component_WorkingIntervalTableRow, {
                                          "interval-data": workingInterval,
                                          extractDateFromDayOfWeek: _ctx.extractDateFromDayOfWeek,
                                          onChangesMade: _cache[18] || (_cache[18] = ($event: any) => (_ctx.flagChangesMade(true)))
                                        }, null, 8, ["interval-data", "extractDateFromDayOfWeek"])
                                      ]))
                                    }), 128))
                                  ])
                                ])
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_99, [
                            _createElementVNode("p", _hoisted_100, [
                              _createElementVNode("button", _hoisted_101, _toDisplayString(_ctx.$t('General.Save')), 1)
                            ]),
                            _createElementVNode("p", _hoisted_102, [
                              _createElementVNode("a", {
                                onClick: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.cancelAvailabilityConfig && _ctx.cancelAvailabilityConfig(...args))),
                                class: "button is-light"
                              }, _toDisplayString(_ctx.$t('General.Cancel')), 1)
                            ])
                          ])
                        ], 32))
                      : _createCommentVNode("", true),
                    (_ctx.getVetMode == 'availabilityslots')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_103, [
                          _createElementVNode("iframe", {
                            src: _ctx.iframeSrc,
                            width: "100%",
                            height: "600"
                          }, null, 8, _hoisted_104),
                          _cache[29] || (_cache[29] = _createTextVNode("s "))
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}